import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-utility-add-edit',
  templateUrl: './add-edit.component.html',
  styleUrls: ['./add-edit.component.scss']
})
export class UtilityAddEditComponent implements OnInit {

  @Input() object: any;
  @Input() key: any;
  @Input() extraData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
